import { DatePicker as AntDatePicker } from 'antd';
import { Field } from 'formik';
import moment from 'moment';
import dayjs from 'dayjs';

export const DateTimePicker = ({
  name,
  disableDate,
  disableTime,
  format,
  disabled,
  title,
  initialValues,
  use12Hours,
  timeFormat,
}) => {
  // Function to disable previous month dates and dates in the past
  const disabledDateFunction = (current) => {
    const today = moment().startOf('day');
    return current && (current < moment().startOf('month') || current < today);
  };
  const defaultDateTimeFormat = format || 'MM-DD-YYYY h:mm a';
  const formattedDate = moment(initialValues?.dateStr, 'YYYY-MM-DD').format(
    defaultDateTimeFormat
  );
  const timeFormatToSet = timeFormat || 'H:mm a';
  return (
    <Field name={name}>
      {({ form: { values, setFieldValue } }) => {
        return (
          <div className="w-full">
            <p className="modal__form-el-label mb-2">{title}</p>
            <AntDatePicker
              showTime={{
                format: timeFormatToSet,
                use12Hours: use12Hours || false,
                minuteStep: 5,
              }}
              format={format || defaultDateTimeFormat}
              onChange={(date, dateString) => {
                setFieldValue(name, dateString);
              }}
              value={
                values[name]
                  ? dayjs(values[name], defaultDateTimeFormat)
                  : dayjs(formattedDate, defaultDateTimeFormat)
              }
              onSelect={(date) => {
                const dateString = date.format(defaultDateTimeFormat);
                setFieldValue(name, dateString);
              }}
              popupClassName="custom-date-picker-panel"
              disabledDate={disableDate || disabledDateFunction}
              disabledTime={disableTime}
              disabled={disabled}
              placeholder="Select Date and Time "
              className="custom-date-picker w-full h-[48px] rounded-[5px] text-[#92928F] flex items-center justify-between px-[16px]"
            />
            {/* {meta.touched && meta.error && <div className="error">{meta.error}</div>} */}
          </div>
        );
      }}
    </Field>
  );
};
